<template>
    <div>
        <div class="vx-row w-full mb-6" v-if="libros[0]">
            <template>
                <div class="vx-col md:w-1/4 xl:w-1/4 mt-4" style="min-height: 250px;" v-if="libros[0].weblibro!== null && libros[0].weblibro!== '' && libros[0].weblibro!== 'null'">
                    <vx-card v-if="libros[0]" class="text-center" style="min-height: 250px; cursor: pointer;" @click="datolibro(libros[0].weblibro,1)">
                        <div slot="no-body">
                            <!-- <img class="responsive card-img-top imagencard" style="max-height: 180px;" v-bind:src="'https://cdn-icons-png.flaticon.com/512/3145/3145755.png'"> -->
                            <img class="responsive card-img-top" v-bind:src="$data_book+'websinguia/'+libros[0].weblibro+'/'+libros[0].portada" alt="Card image cap">
                        </div>
                        <div class="mt-2">
                            <div class="w-3/3 mt-2 ml-auto">
                                <p class="font-bold">
                                    Libro Web
                                </p>
                            </div>
                        </div>
                    </vx-card>
                </div>
                <div class="vx-col md:w-1/4 xl:w-1/4 mt-4" style="min-height: 250px;" v-if="libros[0].webrespuesta!== null && libros[0].webrespuesta!== '' && libros[0].webrespuesta!== 'null'">
                    <vx-card v-if="libros[0]" class="text-center" style="min-height: 250px; cursor: pointer;" @click="datolibro(libros[0].webrespuesta,2)">
                        <div slot="no-body">
                            <img class="responsive card-img-top" style="margin: 0 auto;" v-bind:src="$data_book+'webrespuesta/'+libros[0].webrespuesta+'/'+libros[0].portada_respuesta"  alt="Card image cap">
                        </div>
                        <div class="mt-2">
                            <div class="w-3/3 mt-2 ml-auto">
                                <p class="font-bold">
                                    Guía del docente
                                </p>
                            </div>
                        </div>
                    </vx-card>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            libros:[],
            unidadesLibro:[],
        }
    },
    mounted(){
        let me = this;
        me.getLibros()
    },
    methods:{
        async getLibros() {
            let me = this;
            let idlibro = localStorage.getItem('idlibro')
            let region  = localStorage.region
            this.$http.get(this.$server_url + 'desgloselibrousuario/' + idlibro + '/' + region)
                .then(function (response) {
                    me.libros = response.data
                    localStorage.nombrelibroSelec   = me.libros[0].nombrelibro
                    localStorage.carpetaLibroSelec  = response.data[0].weblibro
                })
                .catch(()=>{}),
                this.$http.get(this.$server_url + 'menu_unidades_libros/' + idlibro)
                .then(function (response) {
                    me.unidadesLibro = response.data
                    // console.log(me.unidadesLibro)
                })
                .catch(()=>{})
        },
        //para obtener el listado de los tipos
        datolibro(url,tipo) {
            let me = this;
            //tipo => 1 libro web; 2 = libro respuesta
            localStorage.tipoWeb = tipo
            localStorage.url = url;
            localStorage.vistalibro = 'por_unidad'
            for (let index = 0; index < me.unidadesLibro.length; index++) {
                if (index == 0) {
                    localStorage.pag_inicio = me.unidadesLibro[index].pag_inicio
                }
                localStorage.pag_fin = me.unidadesLibro[index].pag_fin
            }
            let route = this.$router.resolve({
                path: '/docente/libro/digital'
            });
            window.open(route.href, '_blank');
        },
    }
}
</script>